import React from 'react';
import { ButtonGroup, Button } from '@nextui-org/react';

const YearSelector = ({ 
  timeFrame, 
  setTimeFrame, 
  options = [{ value: 12, label: '1 Year' }, { value: 60, label: '5 Years' }],
  unit = 'months'
}) => {
  return (
    <div className="mb-4 flex justify-center">
      <ButtonGroup>
        {options.map(option => (
          <Button 
            key={option.value}
            style={{
              backgroundColor: timeFrame === option.value ? '#245BA9' : 'transparent',
              borderColor: '#245BA9',
              color: timeFrame === option.value ? 'white' : '#245BA9'
            }}
            onClick={() => setTimeFrame(option.value)}
          >
            {option.label}
          </Button>
        ))}
      </ButtonGroup>
    </div>
  );
};

export default YearSelector;